module.exports = __webpack_public_path__ + "static/exercise-img-7-9d5d183a626b7c4fa6d5081dc245dcc3.png";